import React, { createContext, useContext, type ReactNode } from 'react';
import { InstallAppSheet } from '../components/InstallAppSheet';
import { usePwaInstallPrompt } from '../hooks/usePwaInstallPrompt';

type PwaInstallContextValue = ReturnType<typeof usePwaInstallPrompt>;

const PwaInstallContext = createContext<PwaInstallContextValue | null>(null);

export function PwaInstallProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  const install = usePwaInstallPrompt(enabled);

  return (
    <PwaInstallContext.Provider value={install}>
      {children}
      <InstallAppSheet
        open={install.open}
        kind={install.kind}
        canNativeInstall={install.canNativeInstall}
        onDismiss={install.dismiss}
        onInstallAndroid={() => void install.installAndroid()}
      />
    </PwaInstallContext.Provider>
  );
}

export function usePwaInstall(): PwaInstallContextValue {
  const ctx = useContext(PwaInstallContext);
  if (!ctx) {
    throw new Error('usePwaInstall must be used within PwaInstallProvider');
  }
  return ctx;
}
